var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CoverImage',{staticClass:"CampaignImage h-full b-rad-lg",attrs:{"src":_vm.campaign.image_url}},[_c('div',{staticClass:"PlatformIcon__wrapper absolute pos-b-l m-sm"},[_c('PlatformIcon',{attrs:{"platform":_vm.campaign.platform}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }